import { useModal } from 'components/modal/ModalStack';
import { classNames } from 'libs/react';
import { Button } from 'components/Button';
import { ButtonGroup } from 'components/ButtonGroup';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './Confirm.scss';
/**
 * @component Confirm
 * @since 1.0.0
 */
export function Confirm(props) {
    const { style, title, infos, acceptText, refuseText } = Object.assign({ style: 'normal', acceptText: 'Ok', refuseText: 'Cancel' }, props);
    const modal = useModal();
    /**
     * @function onAccept
     * @since 1.0.0
     * @hidden
     */
    function onAccept() {
        modal.dismiss();
        if (props.onAccept) {
            props.onAccept();
        }
    }
    /**
     * @function onRefuse
     * @since 1.0.0
     * @hidden
     */
    function onDismiss() {
        modal.dismiss();
        if (props.onDismiss) {
            props.onDismiss();
        }
    }
    /**
     * @function onRefuse
     * @since 1.0.0
     * @hidden
     */
    function onRefuse() {
        modal.dismiss();
        if (props.onRefuse) {
            props.onRefuse();
        }
    }
    const className = classNames('confirm', 'confirm--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "confirm-body" },
            title && React.createElement(Text, { className: "confirm-title", value: title }),
            infos && React.createElement(Text, { className: "confirm-infos", value: infos })),
        React.createElement("div", { className: "confirm-foot" },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { size: "small", label: refuseText, onPress: onRefuse }),
                React.createElement(Button, { size: "small", style: "primary", label: acceptText, onPress: onAccept })))));
}
